import type {
  V1CreateBookingRequest,
  V1CreateBookingResponse,
} from '@ennismore/booking-api-client';
import { BookingServiceApi, Configuration } from '@ennismore/ows-api-client';
import { useMutation } from 'react-query';

import {
  APIDialect,
  getDefaultApiRequestOptions,
  useEnnismoreApiClientConfig,
} from '@/api';
import { useSkipRedirectSwitch } from '@/availability-fallback/hooks';
import { CreateBookingError } from '@/booking/errors';
import { OHIPBookingServiceClient } from '@/booking/services/ohip-booking.service';
import { OWSBookingServiceClient } from '@/booking/services/ows-booking.service';
import { mapNetworkError } from '@/errors';
import { getBookingGuestFromCount } from '@/hotel';
import { useSessionId } from '@/session/use-session-id.hook';

interface Request {
  body: V1CreateBookingRequest & { locale: { language: string } };
  dialect: APIDialect;
}

export const useCreateBookingMutation = () => {
  const sessionId = useSessionId();
  const clientConfig = useEnnismoreApiClientConfig();

  return useMutation<V1CreateBookingResponse, CreateBookingError, Request>(
    async ({ body, dialect }) => {
      const client =
        dialect === 'ows'
          ? new OWSBookingServiceClient(clientConfig)
          : new OHIPBookingServiceClient(clientConfig);

      return await client.createBooking({ ...body, sessionId });
    }
  );
};
